/** Transparent practice guidance, never a calibrated SAT score. */
export function practiceFocus(domains: Record<string, { correct: number; scored: number }>) {
  return Object.entries(domains).filter(([, d]) => d.scored >= 3 && d.correct < d.scored)
    .sort(([a, x], [b, y]) => x.correct / x.scored - y.correct / y.scored || y.scored - x.scored || a.localeCompare(b))
    .map(([domain, counts]) => ({ domain, ...counts }))[0] ?? null;
}
